import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import ModalCloseButton from './ModalCloseButton';
import { ModalProps } from './ModalProps';

interface Props extends ModalProps {
  hideCloseButton?: boolean;
  maxWidth?: number;
  className?: string;
}

const Layout = styled.section<Partial<Props>>`
  position: relative;
  z-index: ${theme.zIndex.modal + 2};
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? toRem(maxWidth) : toRem(420))};
  height: auto;
  margin: ${toRem(theme.space.xl)} 0;
  padding: ${toRem(theme.space['2xl'])};
  border-radius: ${toRem(22)};
  background-color: ${theme.color.white};
  box-shadow: ${theme.shadow.modal};

  @media (min-width: ${theme.breakpoint.small}px) {
    margin: ${toRem(theme.space['3xl'])} 0;
    padding: ${toRem(theme.space['3xl'])};
  }
`;

const ModalLayout: React.FC<Props> = ({ onClose, hideCloseButton, isActive, maxWidth, children, className, ...rest }) => (
  <Layout isActive={isActive} maxWidth={maxWidth} className={className} {...rest}>
    {!hideCloseButton && <ModalCloseButton onClick={onClose} />}
    {children}
  </Layout>
);

export default ModalLayout;
